import { isFilled } from "@prismicio/client";
import { PrismicRichText } from "@prismicio/react";

export const richTextBase = {
  strong: ({ children }) => <strong className="md">{children}</strong>,
  em: ({ children }) => <em>{children}</em>,
  hyperlink: ({ children, node }) => (
    <a href={node.data.url} className="underline underline-offset-2">
      {children}
    </a>
  ),
};

/**
 * @param {import("@prismicio/client").Content.AztkPresentationSliceDefaultPrimaryInfosItem} item
 */
export const Info = ({ item }) => (
  <div className="flex flex-col gap-.5">
    {isFilled.richText(item.title) && (
      <PrismicRichText
        field={item.title}
        components={{
          ...richTextBase,
          paragraph: ({ children }) => (
            <p className="p-base-n md text-bleu">{children}</p>
          ),
        }}
      />
    )}
    {isFilled.richText(item.text) && (
      <div>
        <PrismicRichText
          field={item.text}
          components={{
            ...richTextBase,
            paragraph: ({ children }) => (
              <p className="p-base-n text-bleu not-last:mb-5">{children}</p>
            ),
          }}
        />
      </div>
    )}
  </div>
);

export default Info;
